// src/services/portfolio.service.js
import apiClient from './api.service';

class PortfolioService {
  async getPortfolioSummary(userId) {
    const response = await apiClient.get(`/portfolio/summary/${userId}`);
    return response.data;
  }

  async getUserSettings(userId) {
    const response = await apiClient.get(`/settings/user/${userId}`);
    return response.data;
  }

  async updateUserSettings(userId, settingsData) {
    const response = await apiClient.put(`/settings/user/${userId}`, {
      yearlyGoal: parseFloat(settingsData.yearlyGoal),
      currency: settingsData.currency || 'KES',
      timezone: settingsData.timezone || 'Africa/Nairobi',
      notificationsEnabled: settingsData.notificationsEnabled !== undefined 
        ? settingsData.notificationsEnabled 
        : true
    });
    return response.data;
  }

  async updateYearlyGoal(userId, yearlyGoal) {
    const response = await apiClient.put(`/settings/user/${userId}`, {
      yearlyGoal: parseFloat(yearlyGoal)
    });
    return response.data;
  }
}
const portfolioService = new PortfolioService();
export default portfolioService;